import { Component, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Login } from 'src/app/core/interface/auth.model';
import { UtilsService } from 'src/app/core/services/utils.service';
import { NgxSpinnerService } from "ngx-spinner";
import { REGEX_PATTERNS } from 'src/app/core/constants/regex-patterns.constant';
import { LITERALS } from 'src/app/core/constants/literals.constant';
import { ChatService } from 'src/app/core/services/chat.service';
import { FacebookLoginProvider, AuthService as LoginServce } from 'angularx-social-login';
import { OnBoardingComponent } from '../auth/on-boarding/on-boarding.component';
import { ErrorMessageComponent } from '../all-modals/error-message/error-message.component';
import { ForgotPasswordComponent } from '../auth/forgot-reset-password/forgot-reset-password.component';

declare var OneSignal: any;
declare let fbq: Function;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  submitted = false;
  isError = false;
  errorMessage = '';
  rememberMe = false;
  playerId: any = '';
  password = 'password';
  redirectUrl = '/dashboard';
  userObj = {
    id: '',
    name: '',
    username: '',
    email: '',
    author: {}
  };
  // isCaptchaVerified: boolean = false

  constructor(
    private activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private formBuilder: FormBuilder,
    private utilService: UtilsService,
    private spinner: NgxSpinnerService,
    private chatService: ChatService,
    private loginService: LoginServce,
  ) {
    this.activatedRoute.queryParams.subscribe((params) => {
      if (params && params.redirect_url) {
        this.redirectUrl = params.redirect_url;
      }
    }).unsubscribe();
    this.loginService.authState.subscribe((user) => {
      // console.log(user);

    });
  }

  ngOnInit() {
    OneSignal.getUserId((userId) => {
      if (userId) {
        this.playerId = userId;
        localStorage.setItem('_appId', userId);
      }
    });
    this.loginForm = this.formBuilder.group({
      email: [null, Validators.compose([Validators.required, Validators.pattern(REGEX_PATTERNS.EMAIL_PATTERN)])],
      password: [null, [Validators.required]],
      rememberMe: [true]
    });
  }

  // verifyCallback(isVerified: boolean) {
  //   if (isVerified === true) {
  //     this.isCaptchaVerified = true;
  //     console.log("Captcha verification is", isVerified)
  //   } else {
  //     console.log("Captcha verification is", isVerified)
  //   }
  // }

  signInWithFB(): void {
    // this.isCaptchaVerified = true;
    this.loginService.signIn(FacebookLoginProvider.PROVIDER_ID).then(response => {
      if (response.authToken) {
        const params = {
          user: {
            email: response.email,
            facebook_id: response.id,
            name: response.name,
            provider: 'facebook',
            profile_url: response.facebook.picture.data.url
          }
        }
        if (params.user.email) {
          this.spinner.show();
          this.authService.login(params).subscribe((res) => {
            this.spinner.hide();
            if (res.body.success) {
              if (res.body.message === 'User Created') {
                fbq('trackCustom', 'SignUp');
                this.activeModal.close();
                const modalRef = this.modalService.open(OnBoardingComponent, { size: 'lg', centered: true });
                modalRef.componentInstance.profileURL = response.facebook.picture.data.url;
                modalRef.componentInstance.confirmation_token = res.body.data.user.user_confirmation_token;
              } else {
                this.setLoginData(res);
              }
            }
          }, (err) => {
            this.spinner.hide();
            this.errorMessage = LITERALS.AUTH.ERROR_MESSAGES.SOMETHING_WENT_WRONG;
            this.isError = true;
          });
        } else {
          const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
          modalRef.componentInstance.message = 'Email is mandatory to set up a ScriptDoor account. So, Please enable email address if you have disabled it or if you have not added email to your Facebook account then add first and try again.';
          this.authService.revokeFacebookAccess(response.id, response.authToken).subscribe((revokeAccess) => {
          });
        }
      }
    });
  }

  setLoginData(response) {
    if (response.body.success) {
      const userData = response.body.data.user;
      this.userObj.id = userData['chat_sku'];
      this.userObj.name = userData['name'];
      this.userObj.username = userData['chat_sku'];
      this.userObj.email = userData['email'];
      this.userObj.author = {
        id: userData['chat_sku'],
        name: userData['name'],
        username: userData['chat_sku'],
        email: userData['email']
      };
      this.chatService.connectToSocket(this.userObj);

      OneSignal.push(() => {
        OneSignal.showSlidedownPrompt();
      });
      var element;
      element = document.querySelector('#onesignal-bell-container');
      if (element) {
        element.style.display = '';
      }
      const token = response.headers.get('Authorization');
      response.body.data['token'] = token;
      this.redirectUser(response.body.data);

      if (this.playerId)
        this.createNotificationRequest(response.body.data.user.id);

      this.activeModal.close();
      this.router.navigateByUrl(this.redirectUrl);
    }
    else if (response.body.status == 422) {
      this.spinner.hide();
      this.isError = true;
      if (response.body.errors) {
        this.errorMessage = response.body.errors;
      } else {
        this.errorMessage = LITERALS.AUTH.ERROR_MESSAGES.INVALID_EMAIL_PASSWORD;
      }
    }
    else if (response.body.status == 415 || response.body.message == 'You have to confirm your email address before continuing.') {
      this.spinner.hide();
      this.isError = true;
      this.errorMessage = LITERALS.AUTH.ERROR_MESSAGES.PLEASE_VERIFY_EMAIL;
    }
    else {
      this.spinner.hide();
      this.errorMessage = LITERALS.AUTH.ERROR_MESSAGES.SOMETHING_WENT_WRONG;
      this.isError = true;
    }
  }

  onSubmit() {
    // if (this.isCaptchaVerified === false) {
    //   alert("Please verify the captcha!");
    //   return;
    // }
    this.submitted = true;
    if (this.loginForm.invalid) {
      return;
    }
    const params: Login = {
      'user': { ...this.loginForm.value }
    };
    this.spinner.show();
    params.user.password = this.utilService.encode(params.user.password);
    this.authService.login(params).subscribe(
      (response: any) => {
        this.setLoginData(response);
      }, (error: any) => {
        this.spinner.hide();
        if (error.error.error == 'You have to confirm your email address before continuing.') {
          this.errorMessage = LITERALS.AUTH.ERROR_MESSAGES.PLEASE_VERIFY_EMAIL;
          this.isError = true;
          // this.isCaptchaVerified = false;
        }
        else {
          this.errorMessage = LITERALS.AUTH.ERROR_MESSAGES.SOMETHING_WENT_WRONG;
          this.isError = true;
          // this.isCaptchaVerified = false;
        }
      });
  }

  redirectUser(userObj) {
    if (this.loginForm.value.rememberMe) {
      localStorage.setItem('rememberMe', this.loginForm.value.rememberMe);
      localStorage.setItem('currentUser', JSON.stringify(userObj));
    }
    else {
      localStorage.setItem('rememberMe', this.loginForm.value.rememberMe);
      sessionStorage.setItem('currentUser', JSON.stringify(userObj));
    }
  }

  closeDialog() {
    this.activeModal.close();
  }

  openForgetPasswordModal() {
    const modalRef = this.modalService.open(ForgotPasswordComponent, {
      size: "lg",
      centered: true,
      backdrop: 'static',
      keyboard: false
    });
    modalRef.componentInstance.modalType = 'forgot';
  }

  openSignupModal() {
    this.closeDialog();
    this.authService.modalOpen('SignUpComponent', 'lg', true);
    return true;
  }

  createNotificationRequest(userId) {
    const obj = {
      device_id: this.playerId,
      plateform: 'web',
      user_id: userId
    };
    this.authService.createNotification(obj).subscribe(
      (response: any) => { });
  }

  togglePassword() {
    if (this.password == 'text') {
      this.password = 'password';
    } else {
      this.password = 'text';
    }
  }

  openSignInLinkedIN() {
    this.authService.signInWithLinkedIN().subscribe(
      (response: any) => {

      })
  }
}
